export const FETCH_ORGANISATIONS_REQUEST =
  'organisations/fetch-organisations-request';
export const FETCH_ORGANISATIONS_SUCCESS =
  'organisations/fetch-organisations-success';
export const FETCH_ORGANISATIONS_FAILURE =
  'organisations/fetch-organisations-failure';

// Lightweight organisations refresh (no tax rates / excel metadata / pictures fan-out)
export const FETCH_ORGANISATIONS_LIGHT_REQUEST =
  'organisations/fetch-organisations-light-request';

export const DISCONNECT_ORGANISATION_REQUEST =
  'organisations/disconnect-organisations-request';
export const DISCONNECT_ORGANISATION_SUCCESS =
  'organisations/disconnect-organisations-success';
export const DISCONNECT_ORGANISATION_FAILURE =
  'organisations/disconnect-organisations-failure';

export const REACTIVATE_ORGANISATION_REQUEST =
  'organisations/reactivate-organisation-request';
export const REACTIVATE_ORGANISATION_SUCCESS =
  'organisations/reactivate-organisation-success';
export const REACTIVATE_ORGANISATION_FAILURE =
  'organisations/reactivate-organisation-failure';

export const EDIT_ORGANISATION_REQUEST =
  'organisations/edit-organisations-request';
export const EDIT_ORGANISATION_SUCCESS =
  'organisations/edit-organisations-success';
export const EDIT_ORGANISATION_FAILURE =
  'organisations/edit-organisations-failure';

export const FETCH_ADD_URL_REQUEST = 'organisations/fetch-add-url-request';
export const FETCH_ADD_URL_SUCCESS = 'organisations/fetch-add-url-success';
export const FETCH_ADD_URL_FAILURE = 'organisations/fetch-add-url-failure';

export const FETCH_ACCOUNTS_REQUEST = 'organisations/fetch-accounts-request';
export const FETCH_ACCOUNTS_SUCCESS = 'organisations/fetch-accounts-success';
export const FETCH_ACCOUNTS_FAILURE = 'organisations/fetch-accounts-failure';

export const FETCH_ORGANISATION_CONTACTS_REQUEST =
  'organisations/fetch-organisation-contacts-request';
export const FETCH_ORGANISATION_CONTACTS_SUCCESS =
  'organisations/fetch-organisation-contacts-success';
export const FETCH_ORGANISATION_CONTACTS_FAILURE =
  'organisations/fetch-organisation-contacts-failure';

export const CREATE_EXCEL_CONTACT_REQUEST =
  'organisations/create-excel-contact-request';
export const CREATE_EXCEL_CONTACT_SUCCESS =
  'organisations/create-excel-contact-success';
export const CREATE_EXCEL_CONTACT_FAILURE =
  'organisations/create-excel-contact-failure';

export const UPDATE_EXCEL_CONTACT_REQUEST =
  'organisations/update-excel-contact-request';
export const UPDATE_EXCEL_CONTACT_SUCCESS =
  'organisations/update-excel-contact-success';
export const UPDATE_EXCEL_CONTACT_FAILURE =
  'organisations/update-excel-contact-failure';

export const DELETE_EXCEL_CONTACT_REQUEST =
  'organisations/delete-excel-contact-request';
export const DELETE_EXCEL_CONTACT_SUCCESS =
  'organisations/delete-excel-contact-success';
export const DELETE_EXCEL_CONTACT_FAILURE =
  'organisations/delete-excel-contact-failure';

export const CONNECT_CIN7_ENTITY_REQUEST =
  'organisations/connect-cin7-entity-request';
export const CONNECT_CIN7_ENTITY_SUCCESS =
  'organisations/connect-cin7-entity-success';
export const CONNECT_CIN7_ENTITY_FAILURE =
  'organisations/connect-cin7-entity-failure';

// export const POST_SAVE_REFRESH_MAPPING_DATA =
//   'organisations/post-save-refresh-mapping-data';

export const UPDATE_ENTITY_MEMBERS = 'organisations/update-entity-members';
export const UPDATE_ENTITY_MEMBERS_BULK =
  'organisations/update-entity-members-bulk';
export const UPDATE_SUBMISSION_LOG = 'organisations/update-submission-log';

export const RESET_ORGANISATION_DATA = 'organisations/reset-organisation-data';
export const UPDATE_ORGANISATION_DATA =
  'organisations/update-organisation-data';
export const UPDATE_ORGANISATION_CHART_OF_ACCOUNTS =
  'organisations/update-organisation-chart-of-accounts';
export const UPDATE_ORGANISATION_TAX_RATES =
  'organisations/update-organisation-tax-rates';
export const UPDATE_ORGANISATION_TOTAL_TAX_BALANCE =
  'organisations/update-organisation-total-tax-balance';

// tax-rates-related constants have been moved to store/tax-rates/constants.ts

export const UPLOAD_ORGANISATION_ATTACHMENT_REQUEST =
  'organisations/upload-organisation-attachment-request';
export const UPLOAD_ORGANISATION_ATTACHMENT_SUCCESS =
  'organisations/upload-organisation-attachment-success';
export const UPLOAD_ORGANISATION_ATTACHMENT_FAILURE =
  'organisations/upload-organisation-attachment-failure';

export const DELETE_ORGANISATION_ATTACHMENT_REQUEST =
  'organisations/delete-organisation-attachment-request';
export const DELETE_ORGANISATION_ATTACHMENT_SUCCESS =
  'organisations/delete-organisation-attachment-success';
export const DELETE_ORGANISATION_ATTACHMENT_FAILURE =
  'organisations/delete-organisation-attachment-failure';

export const DOWNLOAD_ORGANISATION_ATTACHMENT_REQUEST =
  'organisations/download-organisation-attachment-request';
export const DOWNLOAD_ORGANISATION_ATTACHMENT_SUCCESS =
  'organisations/download-organisation-attachment-success';
export const DOWNLOAD_ORGANISATION_ATTACHMENT_FAILURE =
  'organisations/download-organisation-attachment-failure';

export const ADD_ORGANISATION_REQUEST =
  'organisations/add-organisation-request';
export const ADD_ORGANISATION_SUCCESS =
  'organisations/add-organisation-success';
export const ADD_ORGANISATION_FAILURE =
  'organisations/add-organisation-failure';
export const CREATE_ENTITY_GROUP_REQUEST =
  'organisations/create-entity-group-request';
export const CREATE_ENTITY_GROUP_SUCCESS =
  'organisations/create-entity-group-success';
export const CREATE_ENTITY_GROUP_FAILURE =
  'organisations/create-entity-group-failure';
export const UPDATE_ENTITY_GROUP_REQUEST =
  'organisations/update-entity-group-request';
export const UPDATE_ENTITY_GROUP_SUCCESS =
  'organisations/update-entity-group-success';
export const UPDATE_ENTITY_GROUP_FAILURE =
  'organisations/update-entity-group-failure';
export const DELETE_ENTITY_GROUP_REQUEST =
  'organisations/delete-entity-group-request';
export const DELETE_ENTITY_GROUP_SUCCESS =
  'organisations/delete-entity-group-success';
export const DELETE_ENTITY_GROUP_FAILURE =
  'organisations/delete-entity-group-failure';
export const CLEAR_PENDING_NAVIGATE_AFTER_CREATE =
  'organisations/clear-pending-navigate-after-create';

export const SET_UPLOAD_TRANSACTIONS_TEMP =
  'organisations/set-upload-transactions-temp';
export const CLEAR_UPLOAD_TRANSACTIONS_TEMP =
  'organisations/clear-upload-transactions-temp';

export const UPLOAD_EXCEL_TRANSACTIONS_REQUEST =
  'organisations/upload-excel-transactions-request';
export const UPLOAD_EXCEL_TRANSACTIONS_SUCCESS =
  'organisations/upload-excel-transactions-success';
export const UPLOAD_EXCEL_TRANSACTIONS_FAILURE =
  'organisations/upload-excel-transactions-failure';

export const CLEAR_UPLOAD_EXCEL_RESULT =
  'organisations/clear-upload-excel-result';

export const FETCH_EXCEL_FILES_METADATA_REQUEST =
  'organisations/fetch-excel-files-metadata-request';
export const FETCH_EXCEL_FILES_METADATA_SUCCESS =
  'organisations/fetch-excel-files-metadata-success';
export const FETCH_EXCEL_FILES_METADATA_FAILURE =
  'organisations/fetch-excel-files-metadata-failure';

export const DELETE_EXCEL_TRANSACTIONS_FILE_REQUEST =
  'organisations/delete-excel-transactions-file-request';
export const DELETE_EXCEL_TRANSACTIONS_FILE_SUCCESS =
  'organisations/delete-excel-transactions-file-success';
export const DELETE_EXCEL_TRANSACTIONS_FILE_FAILURE =
  'organisations/delete-excel-transactions-file-failure';

export const FETCH_UPLOADED_FILE_TRANSACTIONS_REQUEST =
  'organisations/fetch-uploaded-file-transactions-request';
export const FETCH_UPLOADED_FILE_TRANSACTIONS_SUCCESS =
  'organisations/fetch-uploaded-file-transactions-success';
export const FETCH_UPLOADED_FILE_TRANSACTIONS_FAILURE =
  'organisations/fetch-uploaded-file-transactions-failure';

export const FETCH_ALL_EXCEL_TRANSACTIONS_REQUEST =
  'organisations/fetch-all-excel-transactions-request';
export const FETCH_ALL_EXCEL_TRANSACTIONS_SUCCESS =
  'organisations/fetch-all-excel-transactions-success';
export const FETCH_ALL_EXCEL_TRANSACTIONS_FAILURE =
  'organisations/fetch-all-excel-transactions-failure';

// Delete single Excel transaction (row-level delete in transactions tab)
export const DELETE_EXCEL_TRANSACTION_REQUEST =
  'organisations/delete-excel-transaction-request';
export const DELETE_EXCEL_TRANSACTION_SUCCESS =
  'organisations/delete-excel-transaction-success';
export const DELETE_EXCEL_TRANSACTION_FAILURE =
  'organisations/delete-excel-transaction-failure';

// Update single Excel transaction
export const UPDATE_EXCEL_TRANSACTION_REQUEST =
  'organisations/update-excel-transaction-request';
export const UPDATE_EXCEL_TRANSACTION_SUCCESS =
  'organisations/update-excel-transaction-success';
export const UPDATE_EXCEL_TRANSACTION_FAILURE =
  'organisations/update-excel-transaction-failure';

/** Add manual Excel journal rows (backend stores under "Manual Entries"). */
export const ADD_EXCEL_TRANSACTIONS_REQUEST =
  'organisations/add-excel-transactions-request';
export const ADD_EXCEL_TRANSACTIONS_SUCCESS =
  'organisations/add-excel-transactions-success';
export const ADD_EXCEL_TRANSACTIONS_FAILURE =
  'organisations/add-excel-transactions-failure';

/** Multi-line transaction drawer: sequential saves so takeLatest does not drop updates. */
export const SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_REQUEST =
  'organisations/save-excel-drawer-transactions-batch-request';
export const SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_SUCCESS =
  'organisations/save-excel-drawer-transactions-batch-success';
export const SAVE_EXCEL_DRAWER_TRANSACTIONS_BATCH_FAILURE =
  'organisations/save-excel-drawer-transactions-batch-failure';

/**
 * Open-drawer-only map of saved transaction id hops (`old → newTransactionId`).
 * Cleared when the edit drawer opens or closes.
 */
export const CLEAR_DRAWER_TRANSACTION_ID_MAP =
  'organisations/clear-drawer-transaction-id-map';

export const UPLOAD_RECEIPT_REQUEST = 'organisations/upload-receipt-request';
export const UPLOAD_RECEIPT_SUCCESS = 'organisations/upload-receipt-success';
export const UPLOAD_RECEIPT_FAILURE = 'organisations/upload-receipt-failure';

export const UPLOAD_RECEIPT_TO_PROVIDER_REQUEST =
  'organisations/upload-receipt-to-provider-request';
export const UPLOAD_RECEIPT_TO_PROVIDER_SUCCESS =
  'organisations/upload-receipt-to-provider-success';
export const UPLOAD_RECEIPT_TO_PROVIDER_FAILURE =
  'organisations/upload-receipt-to-provider-failure';

export const FETCH_LAST_RECEIPT_UPLOAD_STATUS_REQUEST =
  'organisations/fetch-last-receipt-upload-status-request';
export const FETCH_LAST_RECEIPT_UPLOAD_STATUS_SUCCESS =
  'organisations/fetch-last-receipt-upload-status-success';
export const FETCH_LAST_RECEIPT_UPLOAD_STATUS_FAILURE =
  'organisations/fetch-last-receipt-upload-status-failure';

export const CLEAR_RECEIPT_UPLOAD_STATUS =
  'organisations/clear-receipt-upload-status';

export const FETCH_RECEIPT_STATISTICS_ALL_REQUEST =
  'organisations/fetch-receipt-statistics-all-request';
export const FETCH_RECEIPT_STATISTICS_ALL_SUCCESS =
  'organisations/fetch-receipt-statistics-all-success';
export const FETCH_RECEIPT_STATISTICS_ALL_FAILURE =
  'organisations/fetch-receipt-statistics-all-failure';

export const FETCH_RECEIPT_STATISTICS_ENTITY_REQUEST =
  'organisations/fetch-receipt-statistics-entity-request';
export const FETCH_RECEIPT_STATISTICS_ENTITY_SUCCESS =
  'organisations/fetch-receipt-statistics-entity-success';
export const FETCH_RECEIPT_STATISTICS_ENTITY_FAILURE =
  'organisations/fetch-receipt-statistics-entity-failure';

export const INVALIDATE_RECEIPT_STATISTICS =
  'organisations/invalidate-receipt-statistics';

export const SET_TRANSACTIONS_REVIEWED_REQUEST =
  'organisations/set-transactions-reviewed-request';
export const SET_TRANSACTIONS_REVIEWED_SUCCESS =
  'organisations/set-transactions-reviewed-success';
export const SET_TRANSACTIONS_REVIEWED_FAILURE =
  'organisations/set-transactions-reviewed-failure';

// Bulk update Excel transactions (mass edit: same field(s) for multiple rows)
export const BULK_UPDATE_EXCEL_TRANSACTIONS_REQUEST =
  'organisations/bulk-update-excel-transactions-request';
export const BULK_UPDATE_EXCEL_TRANSACTIONS_SUCCESS =
  'organisations/bulk-update-excel-transactions-success';
export const BULK_UPDATE_EXCEL_TRANSACTIONS_FAILURE =
  'organisations/bulk-update-excel-transactions-failure';

// Fetch Excel activity logs for an organisation (transactions timeline)
export const FETCH_EXCEL_ACTIVITY_LOGS_REQUEST =
  'organisations/fetch-excel-activity-logs-request';
export const FETCH_EXCEL_ACTIVITY_LOGS_SUCCESS =
  'organisations/fetch-excel-activity-logs-success';
export const FETCH_EXCEL_ACTIVITY_LOGS_FAILURE =
  'organisations/fetch-excel-activity-logs-failure';

// Add a custom Excel activity note for an organisation
export const ADD_EXCEL_ACTIVITY_NOTE_REQUEST =
  'organisations/add-excel-activity-note-request';
export const ADD_EXCEL_ACTIVITY_NOTE_SUCCESS =
  'organisations/add-excel-activity-note-success';
export const ADD_EXCEL_ACTIVITY_NOTE_FAILURE =
  'organisations/add-excel-activity-note-failure';

// Fetch tracking categories for an organisation (e.g. Xero tracking categories)
export const FETCH_TRACKING_CATEGORIES_REQUEST =
  'organisations/fetch-tracking-categories-request';
export const FETCH_TRACKING_CATEGORIES_SUCCESS =
  'organisations/fetch-tracking-categories-success';
export const FETCH_TRACKING_CATEGORIES_FAILURE =
  'organisations/fetch-tracking-categories-failure';

// Fetch transaction items for an organisation (e.g. Xero items)
export const FETCH_TRANSACTION_ITEMS_REQUEST =
  'organisations/fetch-transaction-items-request';
export const FETCH_TRANSACTION_ITEMS_SUCCESS =
  'organisations/fetch-transaction-items-success';
export const FETCH_TRANSACTION_ITEMS_FAILURE =
  'organisations/fetch-transaction-items-failure';

// connect to google drive
export const REGISTER_DRIVE_FOLDER = 'organisations/register-drive-folder';
export const SAVE_GOOGLE_TOKEN = 'organisations/save-google-token';
export const SET_GOOGLE_ACCESS_TOKEN = 'organisations/set-google-access-token';
export const GET_DRIVE_SCANNER_STATUS =
  'organisations/get-drive-scanner-status';
export const SET_DRIVE_SCANNER_STATUS =
  'organisations/set-drive-scanner-status';
export const GET_FILES_UPLOAD_HISTORY =
  'organisations/get-files-upload-history';
export const SET_FILES_UPLOAD_HISTORY =
  'organisations/set-files-upload-history';
export const UPDATE_RECEIPT_FILE_STATUS =
  'organisations/update-receipt-file-stats';
export const DISCONNECT_FOLDER = 'organisations/disconnect-folder';
export const RESCAN_FILE = 'organisations/rescan-file';
export const GENERATE_SCAN_EMAIL = 'organisations/generate-scan-email';
export const SET_SCAN_EMAIL = 'organisations/set-scan-email';
export const GET_SCAN_EMAIL_STATUS = 'organisations/get-scan-email-status';
export const COMPLETE_SCAN_STEPS_REQUEST =
  'organisations/complete-scan-steps-request';
export const COMPLETE_SCAN_STEPS_SUCCESS =
  'organisations/complete-scan-steps-success';
export const COMPLETE_SCAN_STEPS_FAILURE =
  'organisations/complete-scan-steps-failure';

export const HMRC_FRAUD_HEADER_TEST_REQUEST =
  'organisations/hmrc-fraud-header-test-request';
export const HMRC_FRAUD_HEADER_TEST_SUCCESS =
  'organisations/hmrc-fraud-header-test-success';
export const HMRC_FRAUD_HEADER_TEST_FAILURE =
  'organisations/hmrc-fraud-header-test-failure';
